export const options = [
  { label: 'Brief', path: '/brief', completed: false, disabled: false },
  { label: 'Proposal', path: '/proposal', completed: false, disabled: false },
  { label: 'Agreement', path: '/agreement', completed: false, disabled: false },
  { label: 'Design Files', path: '/files', completed: false, disabled: false },
];
